export default "__VITE_ASSET__C8t1CwWi__"